import {
  AddCircle
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Stack,
  Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import * as React from "react";
import plusIcon from '../../assets/images/icons/plusIcon.svg'
import { visuallyHidden } from "@mui/utils";
import useDebounce from "../../hooks/use.debounce";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/routes";
import { getAllBrandsforListing } from "./action";
import { updateBrand } from "./brandSlice";
import CustomPagination from "../../utils/CustomPagination";
import CreateBrandModal from "../../components/dialog/CreateBrandModal";

function EnhancedTableHead(props) {
  const { order, orderBy } = props;

  const headCells = [
    {
      id: "logo",
      numeric: false,
      disablePadding: true,
      label: "Brand Name",
      type: "",
    },
    {
      id: "product_name",
      numeric: false,
      disablePadding: true,
      label: "Product Name",
      type: "",
    },
    {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "Action",
      type: "",
    },
  ];

  return (
    <TableHead className="hideActionSort">
      <TableRow sx={{ background: '#DBECFF !important', height: "50px", "& th": { backgroundColor: "inherit !important" }, }}>
        {headCells.map((headCell, index) => {
          return (
            <TableCell
              key={headCell?.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{ width: `calc(100% / ${headCells.length})`, textAlign: index > 0 ? "center" : "left" }}>
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                IconComponent={() => null}>
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

export default function BrandsForCompany() {
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [showCreateBrandModal,setShowCreateBrandModal] = React.useState(false);
  const [editedBrand,setEditedBrand] = React.useState({product:[{name:""}],brandName:"",brandImage:""})
  const dispatch = useDispatch();
  const {
    limit,
    page,
    search,
    sort_key,
    totalPages,
    listing,
  } = useSelector((state) => state.brandSlice);
  const debouncedSearch = useDebounce(search, 500);
  const handleChange = (value) => {
    dispatch(updateBrand({ page: value - 1 }));
    dispatch(getAllBrandsforListing());
  };
React.useEffect(() => {
}, [listing]);
  const handleRequestSort = (
    event,
    property
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    dispatch(
      updateBrand({
        sort_type: isAsc ? "asc" : "desc",
        sort_key: property,
      }),
    );
    dispatch(getAllBrandsforListing());
  };

  React.useEffect(() => {
    dispatch(getAllBrandsforListing());

  }, [debouncedSearch]);

  return (
    <>
      <Stack direction={"column"} gap={2}>
        <Stack
          className="mainTitle flex-wrap"
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{
            minHeight: '42px',
            padding: '16px'
          }}>
          <Typography className="page-title" variant="h1">Brand Management</Typography>
          <button
            className="btnPrimary d-flex justify-content-center align-items-center flex-row"
            variant="contained"
            color="primary"
            startIcon={<AddCircle />}
            // onClick={() => navigate("/company-brands/add")}
            onClick={()=>{setShowCreateBrandModal(true);setEditedBrand({product:[{name:""}],brandName:"",brandImage:""})}}
            >
            <img src={plusIcon} alt="plusIcon" width={20} height={20} />&nbsp;Create Brand
          </button>
        </Stack>
        <Box
          sx={{
            backgroundColor: '#fff',
            transition: 'all .5s ease-in-out',
            position: 'relative',
            overflow: 'hidden',
          }}>
          <TableContainer>
            <Table aria-labelledby="tableTitle">
              <EnhancedTableHead
                order={order}
                orderBy={sort_key}
                onRequestSort={handleRequestSort}
                numSelected={0}
                onSelectAllClick={function (
                ) {
                  throw new Error("Function not implemented.");
                }}
              />
              <TableBody>
                {listing && listing?.length ? (
                  listing?.map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row?.id}
                        className={"tableRow"}
                        sx={{
                          "&:hover": {
                            backgroundColor: '#F0F7FF !important', "& td": {
                              backgroundColor: "inherit !important"
                            },
                          }, height: '60px'
                        }}>
                        <TableCell component="td" scope="row" className=" align-items-center" padding="none">
                          <span className="d-flex align-items-center"> <Avatar
                            alt={row?.brandName}
                            src={row.brandImage ? row?.brandImage : "/profile.jpg"}
                            sx={{ height: '35px', width: '35px', borderRadius: "50%", marginRight: '8px' }}
                          />
                            {row?.brandName || "N/A"}</span>
                        </TableCell>
                        <TableCell component="td" scope="row" padding="none" sx={{ textAlign: 'center' }}>
                          {row?.product?.map((v) => v.name)?.toString()}
                        </TableCell>
                        <TableCell component="td" scope="row" padding="none" sx={{ textAlign: 'center' }}>
                          <Stack direction={"row"} gap={0.5} alignItems="center" justifyContent="center">
                            <div>
                              <span className="editIcon"
                                style={{ color: "#0077FF" }}
                                onClick={()=>{
                                  setShowCreateBrandModal(true);
                                  setEditedBrand(row)
                                }}
                                // onClick={() => navigate(`${ROUTES.BRANDS_FOR_COMPANY}/${row.id}`, { state: row })}
                              >
                                Edit
                              </span>
                            </div>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow colSpan={10}>
                    <TableCell colSpan={10} style={{ textAlign: 'center' }}>
                      <Typography
                        color="inherit"
                        variant="subtitle1"
                        alignItems={"center"}
                        component="h3">
                        No Data found!
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Stack
            sx={{
              background: 'transparent',
              height: '60px',
              border: '1px solid #E9EAEB'
            }}
            direction="row"
            alignItems={"center"}
            justifyContent={"flex-end"}>
            <CustomPagination
              count={Math.ceil(totalPages / limit) || 0}
              onChange={handleChange}
              currentPage={page}
              defaultPage={1} siblingCount={1} boundaryCount={1} />
          </Stack>
        </Box>
      </Stack>
      <CreateBrandModal open={showCreateBrandModal} setOpen={setShowCreateBrandModal} editedBrand={editedBrand}/>

    </>
  );
}
